module.exports = __webpack_public_path__ + "img/tabs1-4.a953c277.png";